import type React from "react"
import { memo } from "react"
import { ReactComponent as PennyIcon } from "../../assets/icons/penny_icon.svg"

type LoadingProps = {
  messages?: {
    title: string
    subtitle: string
  }
}

const Loading: React.FC<LoadingProps> = ({ messages }) => {
  return (
    <div className="w-full grow flex flex-col gap-y-[29px] items-center justify-center">
      <div className="rounded-full bg-[#F4E34E] w-[80px] h-[80px] flex items-center justify-center">
        <PennyIcon className="loader-penny-icon" />
      </div>
      {!!messages?.title && !!messages.subtitle && (
        <div className="flex items-center justify-center gap-y-4 flex-col">
          {!!messages.title && <span className="text-pn-body-emphasis">{messages.title}</span>}
          {!!messages.subtitle && (
            <span className="text-pn-body-regular text-center max-w-[210px] w-full">{messages.subtitle}</span>
          )}
        </div>
      )}
    </div>
  )
}
export default memo(Loading)
